import { DropZone } from '@components/Files/DropZone';
import { FilePreview } from '@components/Files/FilePreview';
import { useUploadContext } from '@components/Files/UploadProvider';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { BulkJobStep, useCurrentModalContext } from '../../providers/ModalProvider';

export const SelectFilesStep = () => {
  const { step, isLoading, isFormDisabled, error, onCancel, uploadFiles, billingChecksInProgress } =
    useCurrentModalContext();
  const { files } = useUploadContext();

  if (step !== BulkJobStep.SelectFiles) {
    return null;
  }

  const submit = async () => {
    await uploadFiles();
  };

  return (
    <div className="step-wrapper">
      {isLoading || billingChecksInProgress ? <AbsoluteSpinner overlay={true} /> : null}
      <DropZone />
      <div className="previews">
        {files.map((item, index) => {
          return (
            <div key={index} className="file-wrapper">
              <FilePreview item={item} />
            </div>
          );
        })}
      </div>
      {error ? <div className="errorMessage">{error}</div> : null}
      <div className="buttonContainer">
        <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
        <Button className="ml-4" onClick={submit} disabled={isLoading || !files.length || isFormDisabled}>
          Upload Files
        </Button>
      </div>
    </div>
  );
};
